import React, { useState, SetStateAction, useEffect } from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import { useStyles } from './styles';
import { Comment } from '../../@types/records';

interface IProps {
  comments: Comment;
  setComments: React.Dispatch<SetStateAction<Comment>>;
}

const CommentsFormGroup: React.FC<IProps> = ({ comments, setComments }) => {
  const classes = useStyles();
  const [commentsState, setCommentsState] = useState<Comment>(comments);

  const handleChange = (key: string, value: string) => {
    setCommentsState({ ...comments, [key]: value });
  };

  useEffect(() => {
    setCommentsState(comments);
  }, [comments]);

  return (
    <Box className={classes.sectionContainer}>
      <Typography variant="h6">Observações/Descrição</Typography>
      <Grid container xl={12} spacing={2}>
        <Grid item xs={12}>
          <textarea
            name="Observações"
            placeholder="Observações/Descrição"
            className={classes.input}
            value={commentsState.Observações}
            onChange={(event) => {
              handleChange('Observações', event.target.value);
            }}
            onBlur={() => setComments(commentsState)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CommentsFormGroup;
